import { Language } from '@/i18n/i18n.types';

import { User } from '@models/user.types';

/** Giosg room id for the customer service AI bot */
const GIOSG_ASPA_BOT_ROOM_ID = {
  // https://service.giosg.com/settings/live/rooms/33e56cae-c540-11ec-9685-0242ac120005
  FI: '33e56cae-c540-11ec-9685-0242ac120005',
  // https://service.giosg.com/settings/live/rooms/10969340-c540-11ec-96bb-0242ac120005
  EN: '10969340-c540-11ec-96bb-0242ac120005',
} as const satisfies Record<Language, string>;

/** Gets users production Dynamics entry url */
export const getUserCrmUrl = (crmID: string) =>
  `https://satoprod.crm4.dynamics.com/main.aspx?appid=dd25fcc5-53fe-eb11-94ee-002248807766&pagetype=entityrecord&etn=contact&id=${crmID}`;

export const clearGiosg = () => {
  const giosgButton = document.getElementById('giosg_chat_now_button');
  // We want to show giosg only for signed in users
  if (giosgButton) giosgButton.style.visibility = 'hidden';

  if (window._giosg) {
    window._giosg('visitor', 'removeAll');
    window._giosg('chat', 'close', { hide: true });
  }
};

/** Submits user data to giosg so that customer support can see user crm url in the Giosg client */
export const submitGiosgVisitor = ({
  firstName,
  lastName,
  crmID,
  communicationsLanguage,
}: User) => {
  if (!window._giosg || !window.giosg) return;

  const roomList = window.giosg.allowedRooms?.map((room) => room.id);

  window._giosg(
    'visitor',
    'submit',
    {
      username: `${firstName} ${lastName}`,
      crmURL: getUserCrmUrl(crmID),
    },
    // No algorithm used to sign variables
    'plain',
    // Do not replace existing variables
    false,
    // List of rooms that visitor data is submitted to
    roomList && [
      ...roomList,
      // Add hard coded customer service bot ID that is not included in `roomList` for some reason
      GIOSG_ASPA_BOT_ROOM_ID[communicationsLanguage],
    ]
  );
};
